// 取込ヘルパー（中身/TMS）。既存GAS「完全統合版」のHELPERSを純関数として移植。
// 出所: GAS VENDOR_CONFIGS / HELPERS（extractMMDD, lastNumberGroup, stripPhone, parseMoney, normalizeName ほか）。

// 全角→半角・空白正規化（社名・看板名の突合用）。NFKC。
export function normalizeName(s) {
  if (s == null) return ''
  return String(s).normalize('NFKC').replace(/　/g, ' ').replace(/\s+/g, ' ').trim()
}

// 看板名などが自社（エースジャパン）か判定。半角カナ「ｴｰｽｼﾞｬﾊﾟﾝ㈱」等もNFKCで吸収。
export function isAceJapan(s) {
  const n = normalizeName(s).replace(/\s/g, '')
  return n.includes('エースジャパン')
}

// 文字列から MM/DD を拾って {mm, dd} を返す（"2026/07/27 AM" "07/28(火)" "7-27" 等）。
export function extractMMDD(s) {
  if (s == null) return null
  const t = String(s).normalize('NFKC')
  let m = t.match(/(\d{4})[/\-.](\d{1,2})[/\-.](\d{1,2})/) // YYYY/MM/DD
  if (m) return { yyyy: +m[1], mm: +m[2], dd: +m[3] }
  m = t.match(/(\d{1,2})[/\-.](\d{1,2})/)                  // MM/DD
  if (m) return { yyyy: null, mm: +m[1], dd: +m[2] }
  return null
}

// MM/DD 文字列 → ISO(YYYY-MM-DD)。年が無ければ defaultYear を補う。
export function toISODate(s, defaultYear) {
  const d = extractMMDD(s)
  if (!d) return ''
  const y = d.yyyy || defaultYear || new Date().getFullYear()
  const p = (x) => String(x).padStart(2, '0')
  return `${y}-${p(d.mm)}-${p(d.dd)}`
}

// 車番の下位数字グループ（"京都 130 い ･･46" → "46"）。5桁以上は下4桁。
export function lastNumberGroup(s) {
  if (s == null) return ''
  const groups = String(s).normalize('NFKC').match(/\d+/g)
  if (!groups || !groups.length) return ''
  let last = groups[groups.length - 1]
  if (last.length > 4) last = last.slice(-4)
  return last
}

// 電話番号の体裁除去（数字とハイフンのみ）。
export function stripPhone(s) {
  if (s == null) return ''
  return String(s).normalize('NFKC').replace(/[^\d-]/g, '').replace(/-+/g, '-').replace(/^-|-$/g, '')
}

// 金額パース。"53,000円" → 53000。"仮" などの非確定は null（取込対象外の合図）。
export function parseMoney(s) {
  if (s == null || s === '') return 0
  const t = String(s).normalize('NFKC')
  if (/仮|未定|要確認/.test(t)) return null
  const digits = t.replace(/[^\d.-]/g, '')
  if (digits === '' || digits === '-') return 0
  const v = Math.round(parseFloat(digits))
  return Number.isFinite(v) ? v : 0
}

// 最初の非空値を返す（※変更後→基本 のような優先順位付き取得に使う）。
export function firstNonEmpty(...vals) {
  for (const v of vals) {
    if (v != null && String(v).trim() !== '') return v
  }
  return ''
}

// 車種正規化。ハコベルの希望車両/車両サイズ → 社内区分(4tw/10tw…)。
// 出所: GAS vehicleTable（4t→4tw, 増トン/13t→10tw, 大型→10tw, 中型→4tw）。
export function vehicleClass(s) {
  const t = normalizeName(s)
  if (!t) return ''
  if (/大型|10t|10 ?トン|13t|増トン/.test(t)) return '10tw'
  if (/4t|4 ?トン|中型/.test(t)) return '4tw'
  if (/2t|2 ?トン|小型/.test(t)) return '2t'
  return t // 未知はそのまま（後日マスタで正規化）
}

// 発着地の結合表示（都道府県＋市区町村）。空要素は落として結合。
export function joinPlace(...parts) {
  return parts.map((p) => (p == null ? '' : String(p).trim())).filter(Boolean).join('')
}
